import { Link } from "react-router-dom";
import Logo from "@/components/aoria/Logo";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="footer-section"
            className="bg-[#0D1B2A] text-[#FDFDFC] pt-20 md:pt-28"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-5">
                        <Logo
                            tone="light"
                            size={96}
                            data-testid="footer-logo"
                        />
                        <p className="mt-8 max-w-xl text-[#FDFDFC]/90 font-serif italic text-2xl md:text-[1.75rem] leading-snug">
                            Pour l'accessibilité cognitive à l'ère de
                            l'intelligence artificielle.
                        </p>
                        <div
                            data-testid="footer-legal-identity"
                            className="mt-10 text-sm text-[#FDFDFC]/80 space-y-1"
                        >
                            <div>Association loi 1901</div>
                            <div>SIREN 993 013 549</div>
                        </div>
                    </div>

                    <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-10">
                        <div>
                            <p className="eyebrow !text-[#A8B5C8]">Le site</p>
                            <ul className="mt-6 space-y-3 text-sm">
                                <li>
                                    <Link
                                        to="/"
                                        data-testid="footer-accueil"
                                        className="link-underline"
                                    >
                                        Accueil
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/enjeu"
                                        data-testid="footer-enjeu"
                                        className="link-underline"
                                    >
                                        Enjeux
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/outils"
                                        data-testid="footer-outils"
                                        className="link-underline"
                                    >
                                        Outils
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/faq"
                                        data-testid="footer-faq"
                                        className="link-underline"
                                    >
                                        FAQ
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/manifeste"
                                        data-testid="footer-manifeste"
                                        className="link-underline"
                                    >
                                        Manifeste
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/ressources"
                                        data-testid="footer-ressources"
                                        className="link-underline"
                                    >
                                        Ressources
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <p className="eyebrow !text-[#A8B5C8]">Projet</p>
                            <ul className="mt-6 space-y-3 text-sm">
                                <li>
                                    <Link
                                        to="/a-propos"
                                        data-testid="footer-a-propos"
                                        className="link-underline"
                                    >
                                        À propos
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/partenaires"
                                        data-testid="footer-partenaires"
                                        className="link-underline"
                                    >
                                        Partenaires
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/livre-blanc"
                                        data-testid="footer-livre-blanc"
                                        className="link-underline"
                                    >
                                        Livre blanc
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/pour-qui"
                                        data-testid="footer-pour-qui"
                                        className="link-underline"
                                    >
                                        Pour qui
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/contact"
                                        data-testid="footer-contact"
                                        className="link-underline"
                                    >
                                        Contact
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/#participer"
                                        data-testid="footer-newsletter"
                                        className="link-underline"
                                    >
                                        Lettre d'information
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <p className="eyebrow !text-[#A8B5C8]">Légal</p>
                            <ul className="mt-6 space-y-3 text-sm">
                                <li>
                                    <Link
                                        to="/mentions-legales"
                                        data-testid="footer-mentions"
                                        className="link-underline"
                                    >
                                        Mentions légales
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/confidentialite"
                                        data-testid="footer-privacy"
                                        className="link-underline"
                                    >
                                        Confidentialité
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/cookies"
                                        data-testid="footer-cookies"
                                        className="link-underline"
                                    >
                                        Cookies
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="mt-20 pt-8 border-t border-[#FDFDFC]/20 flex flex-col md:flex-row md:items-center md:justify-between gap-4 pb-10">
                    <p className="text-xs text-[#FDFDFC]/70 tracking-wide">
                        © {year} Aoria, Association loi 1901. Tous droits
                        réservés.
                    </p>
                    <p className="text-xs text-[#FDFDFC]/60 tracking-wide">
                        Site sobre, sans cookies de mesure tiers.
                    </p>
                </div>
            </div>
        </footer>
    );
}
